import React, { useState } from 'react';
import './EnrollmentForm.css';
import Alert from '../common/Alert';
const API_URL = process.env.REACT_APP_API_URL || 'https://register.educatory.ac/api';
// const API_URL = 'https://register.educatory.ac/api';
const CouponInput = ({ courseFee, onCouponApplied }) => {
  const [couponCode, setCouponCode] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [appliedCoupons, setAppliedCoupons] = useState([]);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const [alert, setAlert] = useState(null);

  const validateCoupon = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/coupons/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          couponCode,
          courseAmount: courseFee
        }),
      });

      const data = await response.json();
      if (data.success) {
        setCurrentCoupon({
          code: couponCode,
          amount: parseFloat(data.discountAmount),
          finalAmount: parseFloat(data.finalAmount)
        });
        setShowOtpInput(true);
        setCouponCode('');
      } else {
        setError(data.message);
        setAlert({
          type: 'error',
          message: data.message
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to validate coupon';
      setError(errorMessage);
      setAlert({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/coupons/verify-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          otp,
          currentCoupon,
          appliedCoupons,
          courseAmount: courseFee,
          enrollmentId: localStorage.getItem('enrollmentId')
        }),
      });

      const data = await response.json();
      if (data.success) {
        setAppliedCoupons([...appliedCoupons, data.verifiedCoupon]);
        onCouponApplied([...appliedCoupons, data.verifiedCoupon]);
        setShowOtpInput(false);
        setCurrentCoupon(null);
        setOtp('');
      } else {
        setError(data.message);
        setAlert({
          type: 'error',
          message: data.message
        });
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to verify OTP';
      setError(errorMessage);
      setAlert({
        type: 'error',
        message: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  const removeCoupon = (couponToRemove) => {
    const updatedCoupons = appliedCoupons.filter(c => c.code !== couponToRemove.code);
    setAppliedCoupons(updatedCoupons);
    onCouponApplied(updatedCoupons);
  };

  return (
    <div className="coupon-section">
      {alert && (
        <Alert
          message={alert.message}
          type={alert.type}
          onClose={() => setAlert(null)}
        />
      )}
      {!showOtpInput ? (
        <div className="coupon-input">
          <input
            type="text"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
            placeholder={appliedCoupons.length > 0 ? "Enter another coupon code" : "Enter coupon code"}
            disabled={loading}
          />
          <button
            onClick={validateCoupon}
            disabled={loading || !couponCode}
            className="btn btn-primary"
          >
            {loading ? 'Validating...' : 'Apply'}
          </button>
        </div>
      ) : (
        <div className="otp-input">
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP sent to email"
            maxLength={6}
          />
          <button
            onClick={verifyOtp}
            disabled={loading || !otp}
            className="btn btn-primary"
          >
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
        </div>
      )}

      {error && <p className="error-message">{error}</p>}

      {appliedCoupons.length > 0 && (
        <div className="applied-coupons">
          <h4>Applied Coupons:</h4>
          {appliedCoupons.map((coupon, index) => (
            <div key={index} className="coupon-tag">
              <span>{coupon.code} (-₹{coupon.amount})</span>
              <button onClick={() => removeCoupon(coupon)}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CouponInput;
